import { Box, Typography, CircularProgress, Button } from "@mui/material";
import { toToman } from "../../utils/Utils";
import { useRequest } from "../../api/utils/useRequest";
import { BalootUserV2APIs } from "../../api/APIs";
import { useSnackBar } from "../../context/SnackBarContext";
import { useEffect, useState } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import AssetsPastList from "./AssetsPastList";
import { ReactComponent as PastEmptyState } from "../../assets/empty-states/past-empty-state.svg";
import { useNavigate } from "react-router-dom";
import CustomRectangularSkeleton from "../shared/CustomRectangularSkeleton";
import { ReactComponent as QuestionMark } from "../../assets/icons/question-greenbg.svg";
import { OrderRequestStateFarsi } from "../../types/OrderRequestTypes";
import { ActionModal } from "../shared/ActionModal";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";

export default function AssetsPast() {
  const navigate = useNavigate();
  const openSnack = useSnackBar();
  const [orderRequests, setOrderRequests] = useState([]);
  const [investmentDetail, setInvestmentDetail] = useState(null);
  const [page, setPage] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const [error, serError] = useState(false);
  const [open, setOpen] = useState(false);
  const [infoAccordianShow, setInfoAccordianShow] = useState(false);

  const {
    loading,
    result,
    apiCall: getUserInvestmentHistory,
  } = useRequest(BalootUserV2APIs.getUserInvestmentHistory);

  useEffect(() => {
    getPageUserInvestmentHistory();
  }, []);

  const openModal = () => {
    setOpen(true);
  };

  const closeModal = () => {
    setOpen(false);
  };

  const getPageUserInvestmentHistory = () => {
    getUserInvestmentHistory({
      data: { page: page },
      onSuccess: (response) => {
        setInvestmentDetail(response.detail);
        let data = response.list.content;
        setOrderRequests((prev) => [...prev, ...data]);

        setHasMore(!response.list.last);
        setPage((prev) => prev + 1);
      },
      onError: (error) => {
        openSnack(true, { message: error.message });
        setHasMore(false);
        serError(true);
      },
    });
  };

  return (
    <>
      {loading && page === 0 ? (
        <>
          <CustomRectangularSkeleton height={80} />
          <CustomRectangularSkeleton sx={{ mt: 2 }} />
          <CustomRectangularSkeleton sx={{ mt: 2 }} />
          <CustomRectangularSkeleton sx={{ mt: 2 }} />
        </>
      ) : result && orderRequests.length === 0 ? (
        <Box
          sx={{
            mt: 4,
            width: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <PastEmptyState width={172} height={162} />
          <Typography mt={2} variant="subtitle1" color="grey.4">
            سفارش‌های سرمایه‌گذاریت رو اینجا میبینی.
          </Typography>
          <Button
            onClick={() => navigate("../investment")}
            variant="contained"
            color="primary"
            size="small"
            sx={{ color: "common.white", mt: 1, typography: "h6" }}
          >
            شروع سرمایه‌گذاری
          </Button>
        </Box>
      ) : (
        <>
          {investmentDetail && (
            <>
              <Box
                sx={{
                  py: "16px",
                  px: "12px",
                  boxShadow: (theme) => theme.shadows[2],
                  bgcolor: "common.white",
                  borderRadius: "8px",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                  }}
                >
                  <Typography variant="h5" mr={0.5}>
                    وضعیت شما در یک نگاه
                  </Typography>

                  <QuestionMark
                    width={24}
                    height={24}
                    onClick={() => openModal()}
                  />
                </Box>
                {[
                  {
                    title: "مبلغ سرمایه‌گذاری شده از ابتدا(تومان)",
                    value: toToman(investmentDetail.investment),
                  },
                  {
                    title: "سود از ابتدا(تومان)",
                    value: toToman(investmentDetail.profit),
                  },
                ].map((item) => {
                  return (
                    <Box
                      key={item.title}
                      sx={{
                        my: "4px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      <Typography variant="subtitle1" color="grey.3">
                        {item.title}
                      </Typography>
                      <Typography variant="body2" color="grey.2">
                        {item.value}
                      </Typography>
                    </Box>
                  );
                })}
              </Box>
              <ActionModal
                open={open}
                setOpen={setOpen}
                icon={QuestionMark}
                title="وضعیت شما در یک نگاه"
                description="مبلغ سرمایه‌گذاری و سود، از ابتدای خرید صندوق‌ها محاسبه شده، این صندوق‌ها می‌تواند خارج از بلوط خریداری شده باشند."
                isContained={true}
                actionTitle="متوجه شدم"
                action={closeModal}
              />
            </>
          )}
          <Box 
            mt={2}
            sx={{
            py: "10px",
            px: "12px",
            boxShadow: (theme) => theme.shadows[2],
            bgcolor: "common.white",
            borderRadius: "8px",
            overflow: "hidden"
          }}>

            <Box
              onClick={() => setInfoAccordianShow((prev) => !prev)}
              sx={{
                width: "100%",
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Typography
                variant="h5"
                sx={{ flexShrink: 0, fontSize: "12px" }}
                color={"orange.main"}
              >
                {OrderRequestStateFarsi.PENDING}
              </Typography>
              <Box sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between",
              }}>

                <Typography variant="h5" sx={{ flexShrink: 0 }} mr={1}>
                  {result && toToman(result?.pendingOrders?.totalAmount)} تومان
                </Typography>
                <Box sx={{
                  transform: infoAccordianShow ? "rotate(-180deg);" : "rotate(0deg);",
                  transition: "all 0.3s ease",
                  height: "24px"
                }}>
                  <KeyboardArrowUpIcon sx={{ color: "primary.main", height: 20 }} />
                </Box>
              </Box>
            </Box>
            <Box
              sx={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                transition: "all 0.3s ease",
                maxHeight: infoAccordianShow ? '100px' : '0px',
                paddingRight: "30px"
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                  flexGrow: "1",
                  width: "100%",
                }}
              >
                <Typography mt={1} variant="subtitle1" color="grey.3">
                  خرید
                </Typography>
                <Typography mt={1} variant="body2" color="grey.3">
                  {result && toToman(result?.pendingOrders?.buyAmount)} تومان
                </Typography>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                  flexGrow: "1",
                  width: "100%",
                }}
              >
                <Typography mt={1} variant="subtitle1" color="grey.3">
                  فروش
                </Typography>
                <Typography mt={1} variant="body2" color="grey.3">
                  {result && toToman(result?.pendingOrders?.sellAmount)} تومان
                </Typography>
              </Box>
            </Box>
          </Box>
          {result && (
            <InfiniteScroll
              dataLength={orderRequests.length}
              next={getPageUserInvestmentHistory}
              hasMore={hasMore}
              loader={
                <Box
                  sx={{
                    my: 1,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <CircularProgress size={14} />
                </Box>
              }
              scrollableTarget="ordersScrollable"
            >
              <AssetsPastList
                orderRequests={orderRequests}
                page={page - 1}
                result={result}
              />
            </InfiniteScroll>
          )}
        </>
      )}
    </>
  );
}
